import { apiRequest } from './api';

// Pool/Swimming members service
export const poolMembersService = {
  // Get all pool members
  getAllPoolMembers: async () => {
    return await apiRequest('/get_swim_info', {
      method: 'GET',
      includeAuth: true,
    });
  },

  // Get a paginated pool member list for the admin table
  getPoolMembersPage: async ({ page = 1, pageSize = 200, search = '', feesStatus = 'all', signal } = {}) => {
    const params = new URLSearchParams({
      paginated: 'true',
      page: String(page),
      pageSize: String(pageSize),
    });

    if (search) {
      params.set('search', search);
    }

    if (feesStatus && feesStatus !== 'all') {
      params.set('feesStatus', feesStatus);
    }

    return await apiRequest(`/get_swim_info?${params.toString()}`, {
      method: 'GET',
      includeAuth: true,
      signal,
    });
  },

  // Add new swimmer
  addSwimmer: async (swimmerData) => {
    return await apiRequest('/add_swimmer', {
      method: 'POST',
      body: swimmerData,
      includeAuth: true,
    });
  },

  // Update swimmer information
  updateSwimmer: async (swimmerData) => {
    return await apiRequest('/update_swim', {
      method: 'POST',
      body: swimmerData,
      includeAuth: true,
    });
  },

  // Delete swimmer
  deleteSwimmer: async (swimmerId) => {
    return await apiRequest('/delete_swim', {
      method: 'POST',
      body: { _id: swimmerId },
      includeAuth: true,
    });
  },

  // Get recently deleted swimmers
  getRecentlyDeletedSwimmers: async () => {
    return await apiRequest('/get_recently_deleted_swim', {
      method: 'GET',
      includeAuth: true,
    });
  },

  // Restore deleted swimmer
  restoreSwimmer: async (swimmerId) => {
    return await apiRequest('/restore_swim', {
      method: 'POST',
      body: { _id: swimmerId },
      includeAuth: true,
    });
  },

  // Permanently delete swimmer
  permanentlyDeleteSwimmer: async (swimmerId) => {
    return await apiRequest('/permanently_delete_swim', {
      method: 'POST',
      body: { _id: swimmerId },
      includeAuth: true,
    });
  }
};
